module.exports = __webpack_public_path__ + "img/one-piece_fan.prt.cdeeb924.jpg";